import createIcon from '../../createIcon';

/**
 * @component @name DataObject
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA3VjlDNCA5LjU1IDMuNTUgMTAgMyAxMEgyVjE0SDNDMy41NSAxNCA0IDE0LjQ1IDQgMTVWMTdDNCAxOC42NSA1LjM1IDIwIDcgMjBIMTBWMThIN0M2LjQ1IDE4IDYgMTcuNTUgNiAxN1YxNUM2IDEzLjcgNS4xNiAxMi41OCA0IDEyLjE3VjExLjgzQzUuMTYgMTEuNDIgNiAxMC4zIDYgOVY3QzYgNi40NSA2LjQ1IDYgNyA2SDEwVjRIN0M1LjM1IDQgNCA1LjM1IDQgN1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAxMEMyMC40NSAxMCAyMCA5LjU1IDIwIDlWN0MyMCA1LjM1IDE4LjY1IDQgMTcgNEgxNFY2SDE3QzE3LjU1IDYgMTggNi40NSAxOCA3VjlDMTggMTAuMyAxOC44NCAxMS40MiAyMCAxMS44M1YxMi4xN0MxOC44NCAxMi41OCAxOCAxMy42OSAxOCAxNVYxN0MxOCAxNy41NSAxNy41NSAxOCAxNyAxOEgxNFYyMEgxN0MxOC42NSAyMCAyMCAxOC42NSAyMCAxN1YxNUMyMCAxNC40NSAyMC40NSAxNCAyMSAxNEgyMlYxMEgyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DataObject = createIcon('DataObject', [
  [
    'path',
    {
      d: 'M4 7V9C4 9.55 3.55 10 3 10H2V14H3C3.55 14 4 14.45 4 15V17C4 18.65 5.35 20 7 20H10V18H7C6.45 18 6 17.55 6 17V15C6 13.7 5.16 12.58 4 12.17V11.83C5.16 11.42 6 10.3 6 9V7C6 6.45 6.45 6 7 6H10V4H7C5.35 4 4 5.35 4 7Z',
      key: 'oxmvlu',
    },
  ],
  [
    'path',
    {
      d: 'M21 10C20.45 10 20 9.55 20 9V7C20 5.35 18.65 4 17 4H14V6H17C17.55 6 18 6.45 18 7V9C18 10.3 18.84 11.42 20 11.83V12.17C18.84 12.58 18 13.69 18 15V17C18 17.55 17.55 18 17 18H14V20H17C18.65 20 20 18.65 20 17V15C20 14.45 20.45 14 21 14H22V10H21Z',
      key: '1a4pua',
    },
  ],
]);

export default DataObject;
